import { render } from "./StudentDataStep2.vue?vue&type=template&id=9908f488"
import script from "./StudentDataStep2.vue?vue&type=script&lang=js"
export * from "./StudentDataStep2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__